import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, EventEmitter, Input, Output, DestroyRef, inject , signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AccountDialogComponent } from '../modals/account-dialog/account-dialog.component';
import { AccountService, SubscriptionType } from 'src/app/services/account/account.service';
import { environment } from 'src/environments/environment'
import { StackedModalsService } from 'src/app/services/modal/stacked-modals.service';
import { SettingsService } from 'src/app/services/account/settings.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { ConsoleLoggerService } from 'src/app/services/logging/console-logger.service';
import { User } from 'src/app/models/user';
import { ImageProcessingService } from 'src/app/services/account/image-processing.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-profile',
  standalone: true,
  templateUrl: './profile.component.html',
  imports: [CommonModule],
  styleUrls: ['./profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileComponent implements OnInit {

  @Input() loadingMap: string | null = null;
  @Input() dropdownVisible: boolean = false;
  @Output() profileToggleRequested: EventEmitter<void> = new EventEmitter<void>();
  public readonly isAuthorized = signal<boolean>(false);
  public readonly username = signal<string>("");
  public amazonS3BucketUrl: string = environment.AMAZON_S3_BUCKET_URL;
  public readonly subscriptionType = signal<SubscriptionType | null>(null);
  public readonly avatarLink = signal<string>("");

  private readonly destroyRef = inject(DestroyRef);

  constructor(public accountService: AccountService, private readonly cdr: ChangeDetectorRef,
    private readonly stackedModalsService: StackedModalsService, public settingsService: SettingsService,
    public languageService: LanguageService, private readonly consoleLoggerService: ConsoleLoggerService,
    private readonly imageProcessingService: ImageProcessingService) {
  }

  ngOnInit(): void {
    this.accountService.ObservableIsAuthorized.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp != null && resp != undefined) {
        this.isAuthorized.set(resp);
        if (!resp) {
          this.username.set("");
          this.avatarLink.set("");
        }
      }
    });

    this.accountService.ObservableUser.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (resp: User | null) => {
      // Every user update replaces name and avatar, so nothing of a previous user stays when the new one has none.
      if (resp?.Profile) {
        const { FirstName, LastName } = resp.Profile;
        let username = "";
        if (FirstName) {
          username = LastName ? FirstName + " " + LastName : FirstName;
        }
        this.username.set(username);
        if (this.accountService.getUserAvatar()){
          this.avatarLink.set(await this.imageProcessingService.resizeImageUrlToSquare(`${this.amazonS3BucketUrl}/${this.accountService.getUserAvatar()}`, 48));
        }
        else{
          this.avatarLink.set("");
        }
      }
    });


    this.accountService.ObservableSubscriptionType.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((resp) => {
      if (resp) {
        this.subscriptionType.set(resp);
      }
    });
  }

  public profileClick(): void {
    this.profileToggleRequested.emit();
  }

  public openAccountDialog(): void {
    const process = this.accountService.getIsAuthorized() ? "profileEdit" : "signIn";
    this.stackedModalsService.openModal(AccountDialogComponent, {
      data: { process: process },
      autoFocus: false,
      panelClass: 'dialog-snap-to-fullscreen'
    });
  }
}
